/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useRef, useState, useEffect } from 'react';
import Title from '../../Title';
import newsImage from './../../../styles/images/cnbc-default-image.webp';
import GetData from '../../../services/GetData';
import {requests, fileUrl } from '../../../services/Requests';
import Link from 'next/link';
import CategoriesLinks from '../../Shared/CategoriesLinks/CategoriesLinks';
import VideoDuration from '../../HelperComponents/VideoDuration';
import TimeAgoArabicFormat from '../../Shared/TimeAgoCustom/TimeAgoArabicFormat';
import Thumbnail from '../../Thumbnail';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation,Pagination } from 'swiper';
import { Swiper, SwiperSlide ,Navigation,Pagination} from 'apps/frontend/components/SwiperClient/SwiperClient';
import { buildNewsRoute } from 'apps/frontend/services/Util';
import dynamic from 'next/dynamic';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// const Swiper = dynamic(() =>
//   import('swiper/react').then((mod) => mod.Swiper),
//   { ssr: false }
// );

// const SwiperSlide = dynamic(() =>
//   import('swiper/react').then((mod) => mod.SwiperSlide),
//   { ssr: false }
// );


const MostReadSlider: FC = () => {
  
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);

  const [mostReadNewsList, setMostReadNewsList] = useState<any>({});

  useEffect(() => {
    GetData(`${requests.mostReadNews}&limit=10&offset=0`, {}, 'get', false)
      .then((res) => {
        const newsRes = res.data?.response ? res.data?.response : {};
        setMostReadNewsList(newsRes);
      })
      .catch((err) => {
        console.warn(err);
      });

    return () => {
      // This code runs when component is unmounted
      setMostReadNewsList({});
    };
  }, []);

  return (
    <>
      <div className="newsSlider scrollbarWrap mostredSlider">
        <div className="TileBar scrollbarHeader">
          <div className="float-start">
            <div className="sliderArrows text-start">
              <button
                className="slider-arrow arrow-prev"
                ref={navigationPrevRef}
              >
                Previous
              </button>
              <button
                className="slider-arrow arrow-next"
                ref={navigationNextRef}
              >
                Next
              </button>
            </div>

          </div>
          <div className="float-end">
            <Title styles={'TitleBar'}>
              <div className="text-end">
                <h2>الأكثر قراءة</h2>
              </div>
            </Title>
          </div>
          <div className="clearfix"></div>
        </div>

        <Swiper
          navigation={{
            prevEl: navigationPrevRef.current,
            nextEl: navigationNextRef.current,
          }}
          dir="rtl"
          slidesPerView={3}
          spaceBetween={20}
          slidesPerGroup={1}
          breakpoints={{
            // '1800': { slidesPerView: 3 },
            '1024': { slidesPerView: 3 },
            '992': { slidesPerView: 3 },
            '575': { slidesPerView: 2 },
            '375': { slidesPerView: 1.5 },
            '320': { slidesPerView: 1.5 },
          }}
          pagination={false}
          modules={[Navigation, Pagination]}
          className="mySwiper"
        >
          {Object.values(mostReadNewsList).map(
            (newsItem: any, index: number) => {
              newsItem['routePath'] = buildNewsRoute(newsItem?.id, newsItem?.createdAt, newsItem?.seoDetail?.slugLine, newsItem?.title);
              return (
                <SwiperSlide key={index}>
                  <div className="slider-item" key={index}>
                    <li>
                      {

                        newsItem?.contentType === 'VIDEO' ? (
                          <Link href={`/${newsItem?.routePath}`}>
                            <a href="#" aria-label="Go to 1">
                              <div className="NewsImage VideoNews show_mobile">
                                <Thumbnail showThumbnail={true}
                                  className="img-fluid"
                                  src={
                                    newsItem?.thumbnail?.url
                                      ? newsItem?.thumbnail?.url
                                      : newsItem?.thumbnail?.path
                                        ? fileUrl + newsItem?.thumbnail?.path
                                        : newsImage.src
                                  }
                                />


                                <div className="PlayTime">
                                  <VideoDuration data={newsItem?.video} />
                                  <div
                                    className="PlayButton-featured_50 PlayButton-base "
                                    data-type="play"
                                  >
                                    <span className="PlayButton-flyout">
                                      شاهد الآن
                                    </span>
                                    <span className="icon-play-triangle PlayButton-icon">
                                      <i className="fa play_medium"></i>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </a>
                          </Link>
                        ) : (

                          <Link href={`/${newsItem?.routePath}`}>
                            <a href="#" aria-label="Go to 2">
                              <div className="NewsImage show_mobile">
                                <Thumbnail showThumbnail={true}
                                  className="img-fluid"
                                  src={
                                    newsItem?.image?.url
                                      ? newsItem?.image?.url
                                      : newsItem?.image?.path
                                        ? fileUrl + newsItem?.image?.path
                                        : newsImage.src
                                  }
                                />
                              </div>
                            </a>
                          </Link>
                        )
                      }

                      <Link href={`/${newsItem?.routePath}`}>
                        <a href="#" aria-label="Go to 3">{newsItem?.title}</a>
                      </Link>
                      <p>
                        <CategoriesLinks
                          categories={newsItem && newsItem?.categories}
                        />
                        <b>
                          <TimeAgoArabicFormat date={newsItem?.createdAt} />
                        </b>
                      </p>


                    </li>
                  </div>
                </SwiperSlide>
              );
            }
          )}
        </Swiper>
      </div>
    </>
  );
};

export default MostReadSlider;
